import { render, staticRenderFns } from "./PostavshikSverks.vue?vue&type=template&id=557ecbbe&scoped=true"
import script from "./PostavshikSverks.vue?vue&type=script&lang=js"
export * from "./PostavshikSverks.vue?vue&type=script&lang=js"
import style0 from "./PostavshikSverks.vue?vue&type=style&index=0&id=557ecbbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557ecbbe",
  null
  
)

export default component.exports